module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tenants', {
    attrs: {
      "implementlevel": 0
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7e86d8cf", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e86d8cf","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tenants/ProductDev.vue
// module id = 209
// module chunks = 0